var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyDoctorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 7,
    fill: "#4B9BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1021 8.70071H16.9999V10.0146H18.4452V12.489C18.4452 14.6624 16.6769 16.4306 14.5035 16.4306C12.3302 16.4306 10.562 14.6624 10.562 12.489V10.0146H11.9634V8.70071H9.90504C9.54219 8.70071 9.24811 8.9948 9.24811 9.35764V12.489C9.24811 15.387 11.6056 17.7445 14.5036 17.7445C17.4015 17.7445 19.7591 15.387 19.7591 12.489V9.35764C19.7591 8.9948 19.465 8.70071 19.1021 8.70071Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6645 18.2919V21.4014C21.6645 23.2126 20.191 24.6861 18.3798 24.6861C16.5686 24.6861 15.0951 23.2126 15.0951 21.4014V17.1095H13.7813V21.4014C13.7813 23.937 15.844 26 18.3798 26C20.9154 26 22.9784 23.937 22.9784 21.4014V18.2919H21.6645Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3215 14.0438C20.9809 14.0438 19.8906 15.1341 19.8906 16.4745C19.8906 17.8146 20.9809 18.9051 22.3212 18.9051C23.6616 18.9051 24.7519 17.8146 24.7521 16.4745C24.7521 15.1341 23.6616 14.0438 22.3215 14.0438ZM22.3212 17.5913C21.7053 17.5913 21.2042 17.0902 21.2042 16.4745C21.2042 15.8587 21.7052 15.3577 22.3212 15.3577C22.937 15.3577 23.438 15.8587 23.438 16.4745C23.438 17.0902 22.937 17.5913 22.3212 17.5913Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9418 8C11.5789 8 11.2848 8.29408 11.2848 8.65693V10.0584C11.2848 10.4212 11.5789 10.7153 11.9418 10.7153C12.3046 10.7153 12.5987 10.4212 12.5987 10.0584V8.65693C12.5987 8.29408 12.3046 8 11.9418 8Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0222 8C16.6593 8 16.3653 8.29408 16.3653 8.65693V10.0584C16.3653 10.4212 16.6593 10.7153 17.0222 10.7153C17.385 10.7153 17.6791 10.4212 17.6791 10.0584V8.65693C17.6791 8.29408 17.385 8 17.0222 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyDoctorActive);
export default __webpack_public_path__ + "static/media/FamilyDoctorActive.539ea04cd873a168a7ef84a9972de513.svg";
export { ForwardRef as ReactComponent };